module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction",
      "role": "doc-introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-006"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "role": "doc-pagebreak",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Introduction")])]), _c('h1', {
    staticClass: "pre_stit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_vm._v("The Son Who Became Son")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("O")]), _c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("NE OF MY DAUGHTERS")])]), _vm._v(" recently wrote down the first name and middle and last initials of herself, her siblings, and her mother and me, then taped the sheet to our living room wall. The entries for herself and her siblings followed the script exactly. Her mother she listed as “Mom,” me as “Dad,” and our middle initials encountered some difficulty. Do “Mom” and “Dad” belong in a list of names? Of course. That is what she calls us; to her, that is who we are. She knows our proper names, but from where she stands, those matter less. The historical priority of my proper name over the more recently acquired “Dad” is not her concern. Nor does it matter to her that my full proper name is relatively rare, while “Dad,” properly a title, belongs also to millions. When she names her parents, “Mom” and “Dad” are nearest to hand, and for good reason.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This book is about a name—or rather, a title, “Son,” that at one crucial juncture the author of the Epistle to the Hebrews calls a “name.” The fundamental question this book asks is, What does the author of Hebrews mean by calling Jesus the “Son”? Is “Son” a title given Jesus at his enthronement as Messiah, his session at God’s right hand? Or does “Son” denote his eternal inclusion in the identity of the one true God?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In this book I will argue that we should answer “yes” to both questions and that the second is crucial for, not in tension with, the first. More specifically, I will advance three theses about Jesus’ sonship in Hebrews. First, “Son” designates Jesus’ distinct mode of divine existence. The Son eternally "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "role": "doc-pagebreak",
      "title": "2"
    }
  }, [_vm._v("exists as God and as distinct from the Father and the Spirit. Second, “Son” also designates the office of messianic rule to which Jesus is appointed at his enthronement. Jesus is "), _c('i', [_vm._v("appointed")]), _vm._v(" Son when he sits down at God’s right hand in heaven. Third, Jesus can become the messianic Son only because he is the divine Son incarnate. According to Hebrews, “Messiah” is a theandric office: only one who is both divine and human can do all that Hebrews says the Messiah does.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As often when beginning a book like this, before we begin the argument, there are a few preliminary matters to put in place. These are, first, a sketch of Hebrews’ Christology. In this sketch I will outline Hebrews’ portrait of Jesus’ identity and work—who he is and what he does. This sketch will furnish a backdrop for detailed exegesis to follow. Second, I will summarize three scholarly approaches to Hebrews’ Christology, focusing on the title “Son,” and will allege problems with each. And these are not only different problems; all three approaches presuppose that “Son” in Hebrews basically means only one thing. Either Jesus "), _c('i', [_vm._v("is")]), _vm._v(" Son or he "), _c('i', [_vm._v("becomes")]), _vm._v(" Son; it cannot be both. Third, I will preview the book’s argument. In contrast to the prevailing views, in this book I aim to demonstrate that in Hebrews “Son” names both who Jesus is and what he becomes. He is the Son who became Son.")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KETCH")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EBREWS")]), _vm._v("’ C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTOLOGY")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Hebrews’ story of Jesus’ person and work starts at the climax: Jesus’ exaltation to the right hand of God in heaven."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-002",
      "id": "ap_ntb-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" In one elegant, sweeping sentence, after reminding us how God spoke to his people in time past (Heb 1:1), Hebrews asserts that now, at the hinge of history, God has spoken to us in a Son (1:2). This Son is the one whom God appointed heir of all things, through whom God created all things (1:2). This Son is the radiance of God’s glory and impress of his being, and he sustains the universe by his powerful word (1:3). Without pausing for breath, Hebrews proclaims that this Son made purification for sins and then “sat down at the right hand of the Majesty on high, having become as much superior to the angels as the name "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "role": "doc-pagebreak",
      "title": "3"
    }
  }, [_vm._v("he has inherited is more excellent than theirs” (1:3-4). And so Hebrews’ first sentence peaks at the peak of the Son’s saving mission. It lands us at the pinnacle of the Son’s unique achievement.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thus Hebrews’ first sentence, often called its “exordium” or prologue, opens the letter with a striking statement of the Son’s exaltation to God’s throne in heaven. But its scope is not restricted to this exaltation. Instead, Hebrews’ exordium celebrates the Son’s work in creation and providence (1:2-3) and glimpses the radiant depths of the Son’s divine being (1:3). Further, the compact phrase “after making purification for sins” (1:3) presupposes the Son’s entire saving mission, specifically his offering of his body in heaven before he sat down at God’s right hand (cf. 9:24-25; 10:12). The one who sustains all things entered human life in order to set aside sin (cf. 9:26). The one who is the radiance of God sat down next to God after offering himself to God (cf. 9:14)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-003",
      "id": "ap_ntb-003-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This focus on the Son’s enthronement intensifies in the catena of scriptural citations in Hebrews 1:5-14."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-004",
      "id": "ap_ntb-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" At the Son’s exaltation, when he sat down at God’s right hand on high (1:3-4), God said to him, “You are my Son, today I have begotten you” (Heb 1:5; Ps 2:7), fulfilling his ancient promise to be father to David’s heir (Heb 1:5; 2 Sam 7:14). When God led his firstborn into the heavenly world, he said, “Let all God’s angels worship him” (Heb 1:6; cf. Deut 32:43). While the angels are fiery, ethereal servants, the Son is king forever. God himself addresses the Son as God, exclaiming, “Your throne, O God, is forever and ever” (Heb 1:8-9; Ps 45:6-7). And God himself addresses this Son as the Lord who created everything and will outlive everything: “You, Lord, laid the foundation of the earth in the beginning, and the heavens are the work of your hands; they will perish, but you remain” (Heb 1:10-12; "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "role": "doc-pagebreak",
      "title": "4"
    }
  }, [_vm._v("cf. Ps 102:25-27). What God never said to any angel he said to this Son: “Sit at my right hand until I make your enemies a footstool for your feet” (Heb 1:13; cf. Ps 110:1). In God’s presence, angels, like priests, stand to serve; only the Son sits (Heb 1:13-14; cf. 10:11-13).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This meticulously arranged selection of scriptural texts offers us something like a sandwich. The Son’s exaltation to God’s right hand is the bread (1:5, 13). In the middle are biblical elaborations of what it means for the Son to reign on God’s own throne and why he is qualified so to reign (1:6-12). Some things in this sandwich are hard to digest. For instance, if the “today” of “today I have begotten you” (1:5) is the time when the Son takes his seat at God’s right hand, is he not Son before this event? Is Son something he becomes only at his exaltation?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To feel the full force of this question we need to read Hebrews 1:5 in context. In 1:3 the Son sits down at God’s right hand, and in 1:4 he is said to have thereby "), _c('i', [_vm._v("become")]), _vm._v(" “as much superior to the angels as the name he has inherited is more excellent than theirs.” From these verses two more questions immediately press in on us. First, if the Son is somehow identified with God’s very being (1:3) and is the sovereign Creator and sustainer of all things (1:2, 3, 10), how can he "), _c('i', [_vm._v("become")]), _vm._v(" superior to the angels? Isn’t he always already superior to every created being? Second, what is the name the Son inherits in 1:4? Many scholars argue that this name is in fact “Son.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-005",
      "id": "ap_ntb-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" After all, the name is introduced in 1:4—it is actually the last word in the Greek sentence. Then the author immediately asks in 1:5, “For (γάρ, "), _c('i', [_vm._v("gar")]), _vm._v(") to which of the angels did God ever say, ‘You are my Son, today I have begotten you’?” When we ask, “What is the name the Son inherits?” the author seems immediately to answer, “Son.” But how can the one who "), _c('i', [_vm._v("is")]), _vm._v(" Son "), _c('i', [_vm._v("become")]), _vm._v(" Son? If he becomes Son, surely that means he was not Son already? By contrast, if he already is Son, doesn’t that mean his becoming Son only restates or reveals something that was already true of him?")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This paradox at the heart of Hebrews’ Christology is the heart of the book you are reading. These are the questions my three theses answer. For now, we let the tension stand, and we can tour the rest of Hebrews’ Christology more briskly.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "role": "doc-pagebreak",
      "title": "5"
    }
  }, [_vm._v("As 1:3 hints, this Son who existed before the ages came to exist as a human. At his incarnation, this Son “for a little while was made lower than the angels,” and in his death he tasted death for everyone (2:9). He came to share in flesh-and-blood humanity, so he could disarm by his own death the one who had the power of death (2:14-15). In his death Jesus not only defeated the devil but redeemed his people from their sins against God’s first covenant (9:15).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Christ came into the world to do God’s will (10:5-9), ultimately offering the body God had prepared for him in order to sanctify and perfect his people (10:10, 14). To become a merciful and faithful high priest, Jesus “had to be made like his brothers in every respect” (2:17), which involved not only becoming human but also sinlessly enduring temptation (2:18; 4:15). This Son lived an unmistakably human life. In anguished suffering he cried out to God and was answered (5:7). “Although he is the Son, he learned obedience through what he suffered” (5:8, my translation). As the “founder” of his people’s salvation, he had to be made “perfect through suffering” (2:10). After suffering faithfully, Jesus was indeed made perfect, and “he became the source of eternal salvation to all who obey him, being designated by God a high priest after the order of Melchizedek” (5:9-10).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The incarnate Son, like the Levitical priests, was mortal (7:8, 23). He lived, suffered, died. But he rose again with life indestructible and so arose as a priest in the likeness of Melchizedek (7:15-16). When he thus arose, the same one who said to Jesus “You are my Son” also said to him “You are a priest forever” (Heb 5:5-6; Ps 2:7; 110:4), and so he now “holds his priesthood permanently” (Heb 7:24) and “always lives” to intercede for his people (7:25).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When this Son arose, he kept rising, passing through the heavens (4:14), being exalted above the heavens (7:26), and finally entering God’s dwelling itself, the Holy of Holies in the tabernacle in heaven (6:19-20; 8:1-5; 9:11-12, 23-26). Like the Levitical high priests who yearly entered the earthly Holy of Holies with blood, in order to offer it there (9:7), Jesus entered the Holy of Holies in heaven through his own blood, in order to offer to God his own blood, body, and self (7:27; 9:11-14, 24-25; 10:10, 12, 14). After offering to God this singular, sufficient sacrifice, Christ sat down at God’s right hand (1:3; 8:1; 10:12; 12:2), where he reigns over all, and from where he will return to save his people (9:28).")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "role": "doc-pagebreak",
      "title": "6"
    }
  }, [_vm._v("Like most good stories, this one has flashbacks and flash-forwards."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-006",
      "id": "ap_ntb-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" It hints at what’s to come, and what comes after transfigures what came before. This story also holds together as a whole. It begins before creation’s beginning and continues after creation’s end and new beginning (2:5; 12:25-29). This narrative encompasses the Son existing before all things, creating all things, sustaining all things, entering the world as a man, living, dying, rising again, ascending to heaven, offering himself there as high priest and victim, and sitting down at God’s right hand as messianic king. Therefore, David Moffitt precisely describes Hebrews’ narrative Christology as a “proto-credal sequence.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-007",
      "id": "ap_ntb-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This narrative also contains carefully placed points of tension and resolution, prerequisites for its progress and conclusion. The Son had to enter human life to transform it from within. He had to be made like his brothers in every respect in order to become a merciful and faithful high priest. He had to be perfected through suffering. He had to die to destroy death. He had to obtain indestructible life to be appointed high priest. He had to offer himself to God before he could sit down at God’s right hand. When Hebrews’ first sentence lands us at its narrative climax, all this is bundled up, waiting to unfurl. The goal of this book is to follow this unfurling as closely as "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "role": "doc-pagebreak",
      "title": "7"
    }
  }, [_vm._v("possible and so to offer a satisfying account of who the Son is and how he became Son."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-008",
      "id": "ap_ntb-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HREE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHOLARLY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPROACHES")]), _vm._v(", T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEIR")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROBLEMS")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LTERNATIVE")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The preceding sketch lingered over the apparent tension between Jesus being Son and becoming Son. Many scholars have noted this tension and have struggled to resolve it. We can identify three predominant approaches to the question of Jesus’ sonship in Hebrews, which both follow from and lead to divergent construals of Hebrews’ Christology as a whole. In Hebrews, “Son” is not just a prominent but a programmatic title for Jesus. What one does with it is an apt litmus test of—and in some cases, a basis for—how one handles Hebrews’ entire testimony to who Jesus is.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In what follows I will describe three scholarly answers to the question of whether “Son” in Hebrews designates Jesus’ divine identity or his appointment to messianic office at his exaltation. As is the way of such surveys, I will suggest problems with each perspective. Not only that, I will suggest a problem they have in common: each approach treats sonship in Hebrews as a zero-sum game. Each approach treats “Son” as either something Jesus is or something he becomes. All exclude the possibility that the Son became Son.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After surveying these three approaches I will discuss modern scholars who affirm that “Son” relates both to Jesus’ identity as God and to his reign as Davidic Messiah. Such scholars, I suggest, point in the right direction, and I intend to extend their insights further. Admittedly, the claim that the Son became Son is counterintuitive, but my whole argument seeks to demonstrate not only that Hebrews propounds to us this paradoxical claim but also that Hebrews offers reasoned scriptural support for it.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Less-than-divine Christology: Son is what Jesus became. ")])]), _vm._v("The first approach is what we might call, for comparative purposes, a less-than-divine "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "role": "doc-pagebreak",
      "title": "8"
    }
  }, [_vm._v("Christology. This approach starts from the given that Jesus was appointed Son at his exaltation and consequently finds his sonship to entail something less than eternal, divine, personal self-existence. On this view, Son is what Jesus became; it is not what he was already. Consequently, though details vary, this view can fairly be called “adoptionist.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In recent study of Hebrews, this position’s trajectory begins with G. B. Caird’s 1984 essay “Son by Appointment.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-009",
      "id": "ap_ntb-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Caird argues,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("Here, as in the Fourth Gospel, “the Son” is always a title for the man Jesus. He it is whom God appointed heir to the universe and who has now by his heavenly exaltation entered upon that inheritance. Moreover, in one passage after another where the title is used, the idea of appointment is present in the context."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-010",
      "id": "ap_ntb-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In Caird’s view, there is not “a single one of his dignities which he is said to hold in virtue of his heavenly origin. He had to "), _c('i', [_vm._v("become")]), _vm._v(" superior to the angels and to "), _c('i', [_vm._v("inherit")]), _vm._v(" the loftier name (1:4).”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-011",
      "id": "ap_ntb-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Thus, “The author of Hebrews has no place in his thinking for preexistence as an ontological concept. His essentially human Jesus attains to perfection, to preeminence, and even to eternity. Yet it is a high Christology.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-012",
      "id": "ap_ntb-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Whatever Caird means by “high Christology,” what he does not mean is clear: the Son does not personally, eternally exist before becoming human."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-013",
      "id": "ap_ntb-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Caird denies that even Hebrews 1:10-12 can be taken to imply that Christ is “divine (and preexistent).”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-014",
      "id": "ap_ntb-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Instead, Christ “is the man in whom the divine Wisdom has been appointed to dwell, so as to make him the bearer of the whole purpose of creation.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-015",
      "id": "ap_ntb-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In a Festschrift posthumously honoring Caird, his doctoral mentee L. D. Hurst carries forward this interpretive trajectory."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-016",
      "id": "ap_ntb-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" For Hurst, “The question needs to be asked, if only to consider whether—and to what extent—chapter "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak",
      "title": "9"
    }
  }, [_vm._v("one may originally have been read from the point of view of the humanity of Jesus.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-017",
      "id": "ap_ntb-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Indeed Hurst goes on to assert that “the figure in view” throughout Hebrews 1 is “essentially a human one.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-018",
      "id": "ap_ntb-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Given Hurst’s earlier charge that it would be difficult to see how Hebrews 1–2 coheres if “chapter one describes the unique prerogatives of a heavenly being who becomes man,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-019",
      "id": "ap_ntb-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" his labeling the Jesus of Hebrews 1 “essentially human” seems at least to weigh against, if not outright exclude, the idea of Jesus’ personal preexistence. Regarding Hebrews 1:8-9, Hurst feels no need to “enter into elaborate arguments as to whether or not the Son is addressed here as ‘God.’”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-020",
      "id": "ap_ntb-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Further, Hurst takes Hebrews 1:10-12 to indicate not that God addresses Jesus as the active agent of creation but that he is “addressing his own wisdom in its earthly receptacle.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-021",
      "id": "ap_ntb-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" For Hurst, “To what extent notions of a pre-cosmic figure are "), _c('i', [_vm._v("also")]), _vm._v(" present may have to remain a delicate matter of judgment.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-022",
      "id": "ap_ntb-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Yet even if such notions may be present, Hurst avers that they can hold little importance for Hebrews: “It looks, in other words, as though the author’s "), _c('i', [_vm._v("main")]), _vm._v(" interest was not in a uniquely privileged, divine being who becomes man; it is in a human figure who attains to an exalted status.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-023",
      "id": "ap_ntb-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In acknowledged dependence on and critical engagement with Caird, Kenneth Schenck has written an article that investigates the nature of Christ’s sonship, the time of its beginning, and the manner of his preexistence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-024",
      "id": "ap_ntb-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" One of the primary concerns of Schenck’s essay is the tension between Christ being Son and becoming Son. On the one hand, Schenck distinguishes between “Son” as identity and “Son” as role:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("The uniqueness of Christ’s Sonship seems to reflect something particular about his identity, something that makes him alone suitable for enthronement. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak",
      "title": "10"
    }
  }, [_vm._v("Here a distinction between "), _c('i', [_vm._v("identity")]), _vm._v(" and "), _c('i', [_vm._v("role")]), _vm._v(" can be made. At his enthronement, Christ truly "), _c('i', [_vm._v("becomes")]), _vm._v(" Son in the sense that he assumes his royal office and takes his divine ‘appointment,’ but in his "), _c('i', [_vm._v("identity")]), _vm._v(" he has always been the Son, the one whom God had destined to be enthroned from the foundation of the world (cf. 9.26), who bears God’s purpose for humanity (cf. 2.9)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-025",
      "id": "ap_ntb-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For Schenck Christ’s identity as Son is strictly proleptic; it marks him out as "), _c('i', [_vm._v("destined")]), _vm._v(" to become, at his enthronement, God’s appointed ruler."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-026",
      "id": "ap_ntb-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" That Christ “is always the Son” means that he is “destined for his throne.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-027",
      "id": "ap_ntb-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Further, Schenck urges “caution when approaching protological language in the epistle,” and concludes that “the pre-existent Christ only exists as a function of God.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-028",
      "id": "ap_ntb-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Thus,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("When God finally speaks through a Son in the consummation of his creative purpose, he brings about and fulfils the destiny he had planned for creation and humanity, making Christ the bearer of this purpose, the very reflection of God’s glory, the representation of his substance, the embodiment of the creative "), _c('i', [_vm._v("logos")]), _vm._v(" which sustains all things."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-029",
      "id": "ap_ntb-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For Schenck, all these are what the Son "), _c('i', [_vm._v("becomes")]), _vm._v("; none names what he is before and apart from his earthly career. Thus, while Schenck formally distinguishes between “Son” as identity and “Son” as role, he reduces the content of the former to the latter. For Schenck, Jesus being Son eternally and becoming Son at his exaltation are on some level incompatible, and he substantially resolves the tension in favor of the latter."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-030",
      "id": "ap_ntb-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak",
      "title": "11"
    }
  }, [_vm._v("Caird, Hurst, and Schenck all address the apparent tension between Jesus being Son and becoming Son, especially when the former is understood to entail divinity, or at least personal preexistence. All three decide the contest between Jesus being Son and becoming Son in favor of becoming."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-031",
      "id": "ap_ntb-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Positively, they all rightly perceive the importance of Christ’s enthronement for Hebrews’ argument, and they argue, in my view rightly, that in some sense Christ is appointed Son at that enthronement. Yet I would suggest two problems with this “less-than-divine Christology.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-032",
      "id": "ap_ntb-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" First—and this is equally the case for the next two views—the presupposition that Jesus’ being Son and becoming Son are mutually exclusive is by no means self-evident, though interpreters in this category seem to treat it as such.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Second, as I will argue in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter two")]), _vm._v(", in Hebrews Jesus is in fact divine in the fullest sense of the word. By contrast, all three interpreters surveyed here offer an account of the Son’s agency in creation and providence that fails to do justice to the assertions of Hebrews 1:2, 1:3, and 1:10-12. All three fail to account for passages that either directly (1:8-9, 10-12) or indirectly (1:3) identify the Son as God. All three rightly identify the Son’s exaltation as the focus of Hebrews’ first chapter, yet all three wrongly treat that focus as somehow antithetical to the Son’s personal preexistence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-033",
      "id": "ap_ntb-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("Being Son and becoming Son as irreconcilable.")])]), _vm._v(" A second approach treats Jesus’ being Son and becoming Son as fundamentally irreconcilable and refrains from reconciling them. Scholars who take this approach see Hebrews asserting both and treat the resulting Christology as deeply fissured "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "role": "doc-pagebreak",
      "title": "12"
    }
  }, [_vm._v("or even incoherent. As we will see, this stance is related to, though not identical with, the question of whether Hebrews’ Jesus is both human and divine, and whether that, too, would constitute a contradiction. Harold Attridge exemplifies the irreconcilable approach when he writes,")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("Hebrews’s reflections on the significance of Jesus are obviously not a carefully considered systematic statement. There are, in fact, several barely or non-resolved antinomies among the affirmations of the text. The exordium (1:1-3), for example, contains a festive celebration of a “high” christological perspective, and affirms clearly the divine character of the Son and his role in the creation. The following catena (1:5-13) focuses on the exaltation of the Son, and even seems to suggest that his status as Son is dependent on that exaltation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-034",
      "id": "ap_ntb-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Further, in an excursus on sonship in Hebrews that takes its cue from the citation of Psalm 2:7 in Hebrews 1:5, Attridge argues,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("It may be that he took seriously the language of the psalm about Christ “becoming” Son and set this decisive moment either at the creation or some primordial event, or at his incarnation, his baptism, or his exaltation. While the last understanding accords well with what was probably the original function of the catena and with the focus on the exaltation in Hebrews, it is undermined by later passages that speak of Christ as the Son during his earthly life.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Attridge then explores several scholarly solutions to this tension between Jesus being Son already and becoming Son at, likely, his exaltation. Some hold that “the term ‘Son’ is properly applied at the point of exaltation, but proleptically in other contexts.” Some attempt to “reconcile the two christological perspectives” by seeing the Son’s exaltation as not “the creation of a new status” but “the definitive recognition or revelation of what Christ is and has been.” Some, affirming the Son’s preexistence, take the citation of Psalm 2:7 to refer to the Son’s eternal generation. And, finally, some maintain that the text does not reconcile the tension, which derives from the use of conceptually divergent traditions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-035",
      "id": "ap_ntb-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But we should notice what possible solution Attridge does not entertain: that the Son became Son. Attridge takes for granted a zero-sum equation "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "role": "doc-pagebreak",
      "title": "13"
    }
  }, [_vm._v("between these two apparently competitive uses of “Son,” as do, on some level, all the interpreters he surveys. His entire discussion presupposes that “Son” has a single meaning for Hebrews; it speaks of only one reality; it sings only one part. Neither Attridge nor anyone he surveys raises the possibility that the author of Hebrews deliberately uses “Son” to designate both Jesus’ divine identity and the messianic rule to which he accedes at his exaltation.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Attridge himself argues that the author of Hebrews has fused basically incompatible traditions and is “not interested in providing a systematic Christology” that would reconcile these two perspectives."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-036",
      "id": "ap_ntb-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" If priority must go to one, Attridge opts for divine Christology: “There are, in fact, several indications later in the text that the high Christology of the exordium is not merely a rhetorical flourish, but a basic constituent of Hebrews’s portrait of Christ.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-037",
      "id": "ap_ntb-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another scholar who argues that Jesus’ being Son and becoming Son stand in irreconcilable tension is James Dunn, who offers an interpretation of Hebrews’ apparent divine Christology that is not totally unlike that of Caird and company. On the one hand, Dunn asserts, “There is no doubt about the importance of Jesus’ divine sonship for the author of the letter to the "), _c('i', [_vm._v("Hebrews")]), _vm._v(".”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-038",
      "id": "ap_ntb-038-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" And Dunn sees Hebrews as the first New Testament writing “"), _c('i', [_vm._v("to have embraced the specific thought of a pre-existent divine sonship")]), _vm._v(".”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-039",
      "id": "ap_ntb-039-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" On the other hand, however, Dunn sets this preexistence within the context of Hebrews’ “"), _c('i', [_vm._v("indebtedness to Platonic idealism")]), _vm._v("”; he perceives an “impersonal tone” in the references to Jesus as Son in 1:2 and 1:5; and he explicitly denies that Hebrews “"), _c('i', [_vm._v("has attained to the understanding of God’s Son as having had a real personal pre-existence")]), _vm._v(".”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-040",
      "id": "ap_ntb-040-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("However, like Attridge, Dunn feels an acute tension between Jesus being Son and becoming Son: “How can the writer speak of Jesus both as a ‘Son . . . through whom God created the world’ and as a son appointed by virtue of his passion and begotten by means of his exaltation?” The solution toward which Dunn leans is similar to that of Attridge: Hebrews juxtaposes "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak",
      "title": "14"
    }
  }, [_vm._v("incommensurable conceptual frameworks, in Dunn’s case “Platonic cosmology and Judaeo-Christian eschatology.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-041",
      "id": "ap_ntb-041-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Related though not identical to the perceived tension between Jesus being Son and becoming Son is the perceived tension between Jesus being divine and being human. For instance, C. F. D. Moule comments, “But we are still left asking how the individual of the ministry and the post-resurrection glory is related to the pre-existent being.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-042",
      "id": "ap_ntb-042-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Moule’s assumption that these different “states” constitute some fundamental rupture in the identity of the “individual” and “being” in question seems to presuppose logical tension in affirming that Jesus is both divine and human. And, from a rather different perspective, Bart Ehrman points to passages in Hebrews that could be taken to indicate both that Jesus is divine and that he is human, then asks, “How would the author of Hebrews himself have . . . reconciled the divergent views that he appears to have written? Regrettably, we will never know.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-043",
      "id": "ap_ntb-043-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Again, this presupposes tension, perhaps contradiction, in saying both that Jesus is divine and that he is human. We will return to this issue in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter one")]), _vm._v(".")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The problem I find in Attridge and Dunn’s position is one I can only demonstrate to be a problem by making the argument that constitutes this book. That is, this stance seems to assume in advance that Hebrews must use “Son” in only one sense. Therefore, when Hebrews speaks in bracingly high terms of the Son’s being and acts, this necessarily stands in tension with “Son” being something this same figure becomes upon exaltation. This seems to me an a priori assumption rather than a conclusion compelled by Hebrews’ argument."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-044",
      "id": "ap_ntb-044-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak",
      "title": "15"
    }
  }, [_c('b', [_c('i', [_vm._v("Divine Christology: Son already.")])]), _vm._v(" A third prominent position is one that resolves the tension between Jesus being Son and becoming Son in favor of the former. If Jesus is already the divine Son, then there can be no strong sense in which he becomes Son. Either the begetting of Psalm 2:7 in Hebrews 1:5 is eternal, or his becoming Son at his exaltation is actually a restatement or revelation or reaffirmation of a status he already had.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Richard Bauckham opts for the former solution. In a pair of essays"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-045",
      "id": "ap_ntb-045-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" Bauckham argues that “Hebrews portrays Jesus as both truly God and truly human, like his Father in every respect and like humans in every respect.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-046",
      "id": "ap_ntb-046-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Regarding Jesus’ sonship, Bauckham argues, “The most fundamental category is that of the Son of God who shares eternally the unique identity of the Father, the unique identity of the God of Israel and the God of all reality. But sonship to God also characterizes Jesus’ human solidarity with his fellow-humans.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-047",
      "id": "ap_ntb-047-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" So for Bauckham there is some kind of duality to Hebrews’ Son language, and this duality attaches to Jesus’ existence as both divine and human. Nevertheless, while Bauckham recognizes the importance of Jesus’ exaltation for Hebrews’ exordium and opening catena,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-048",
      "id": "ap_ntb-048-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" he argues that Jesus did not in any sense become Son at his exaltation. Bauckham treats “Son” as a zero-sum game: “The divine Son in Hebrews is Son of God from all eternity as well as to all eternity: sonship is the eternal truth of his very being, not simply a role or status given him by God at some point.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-049",
      "id": "ap_ntb-049-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" However, “not simply” is not the only way we might link Jesus being eternal Son and being appointed Son “at some point.” In keeping with this zero-sum assumption, Bauckham takes Psalm 2:7 in Hebrews 1:5 to be spoken not at the exaltation but in the eternal depths of the divine being: “The ‘today’ of ‘Today I have begotten you’ would be the eternal today of the divine eternity.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-050",
      "id": "ap_ntb-050-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak",
      "title": "16"
    }
  }, [_vm._v("However, there are other scholars who affirm Jesus’ fully divine identity in Hebrews and yet see 1:5 as spoken at his exaltation. For instance, Aquila Lee understands “today” in 1:5 as “the day when Jesus was vested with his royal dignity as Son of God, the occasion of his exaltation and enthronement.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-051",
      "id": "ap_ntb-051-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" Yet he also writes, “Assigning the moment of becoming Son to Christ’s exaltation seems to fit in well with the original function of the scriptural catena and the emphasis on the exaltation motif of the letter, but this view has also difficulty with later passages which speak of Jesus as the Son during his earthly life.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-052",
      "id": "ap_ntb-052-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" For Lee, “today I have begotten you” is spoken to Jesus at his enthronement, but this does not mean that Jesus became Son at that point, since he was Son already. After Lee affirms that Jesus is acclaimed as God’s Son at his exaltation, he immediately qualifies this: “However, it needs to be emphasized that this solution does not undermine Jesus’ eternal sonship at all. On the contrary, it indicates that the precise relationship of Jesus’ exaltation and his divine sonship is that of a confirmation of his existing position and status, rather than a conferral of a new status.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-053",
      "id": "ap_ntb-053-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For Lee, since Jesus is Son, he cannot become Son. Lee defines his position over against those who “have maintained that, while the term ‘Son’ is applied to Jesus at the point of his exaltation, it is used proleptically in other contexts.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-054",
      "id": "ap_ntb-054-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" If Jesus became Son at his exaltation, before that the title must necessarily have only applied in a proleptic fashion. This displays the zero-sum logic of Lee’s reading."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-055",
      "id": "ap_ntb-055-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Like Lee, Amy Peeler regards the affirmation that Jesus “became Son upon his exaltation” as necessarily entailing that he “was only proleptically "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "role": "doc-pagebreak",
      "title": "17"
    }
  }, [_vm._v("so before this point.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-056",
      "id": "ap_ntb-056-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Like her diagnosis, Peeler’s prescription also aligns with that of Lee:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("Granting that God proclaims this name (Heb. 1.5)—the name which makes the Son better than the angels—at Jesus’ exaltation, it remains plausible to interpret this announcement not as the establishment of Jesus’ status as God’s Son but as a restatement of that fact. In this way, these words are a fitting proclamation when one who is already a son inhabits his throne."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-057",
      "id": "ap_ntb-057-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For Peeler, to say that Jesus “inhabits” his throne is to say something new of him, but “Son” is not a status newly conferred. Despite its many virtues, Peeler’s reading leaves no room for a substantive distinction between Son as identity and Son as office."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-058",
      "id": "ap_ntb-058-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Despite their substantial differences, the scholarly approaches surveyed above all treat the title “Son” in Hebrews as finally capable of only one meaning. Given this constraint, the three positions exhaust the range of logical possibilities. Either Jesus became Son at his exaltation, and so his bearing the title or identity of Son before that point is strictly proleptic; or Jesus is eternally the divine Son, and so his becoming Son is simply a restatement or manifestation of what he is already; or Hebrews is fundamentally inconsistent at this point.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('b', [_c('i', [_vm._v("An alternative: the Son who became Son. ")])]), _vm._v("However, not all modern scholars share this zero-sum perspective on Jesus’ sonship. For instance, Frank Matera writes,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("There is an implicit distinction between identity and role in the Son of God Christology in Hebrews. From the point of view of "), _c('i', [_vm._v("identity")]), _vm._v(", Christ was Son "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "role": "doc-pagebreak",
      "title": "18"
    }
  }, [_vm._v("of God. But from the point of view of his "), _c('i', [_vm._v("role")]), _vm._v(" in God’s plan for salvation, he becomes the enthroned Son of God, an eternal high priest, at his exaltation. Moreover, it is as the enthroned Son of God and eternal high priest that he brings his brothers and sisters to perfection."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-059",
      "id": "ap_ntb-059-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Further, Matera endorses the apparent paradox of the Son becoming Son, the Son inheriting the name “Son”: “In other words, although the author will not speak of Jesus as the incarnate Son of God until chapter 2, he is already speaking of Jesus as the exalted Son of God in chapter 1. There is a paradoxical sense, then, in which the preexistent Son inherits the name ‘Son.’”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-060",
      "id": "ap_ntb-060-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("D. A. Carson argues the same basic stance, though a touch less explicitly. For Carson, because of the way Hebrews’ prologue ascribes divine acts to the Son, its sonship language")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_vm._v("cannot be restricted to a strictly Davidic-messianic horizon")]), _vm._v(". The writer to the Hebrews, in other words, is prepared to link, within his first chapter, Jesus’ sonship in the Davidic, messianic sense, with his sonship in the sense of his thoroughly divine status, embracing his preexistence and his oneness with God in creation."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-061",
      "id": "ap_ntb-061-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For Carson, “Son” in Hebrews explicitly designates both Jesus’ “thoroughly divine status” and the messianic rule to which he attains. That Carson has no problem with the Son becoming Son seems evident when he writes that Psalm 2:7 “finds its ‘today’ in the resurrection of Jesus and the dawning of his kingdom.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-062",
      "id": "ap_ntb-062-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Finally, among modern scholars I have read, Moises Silva most pointedly expresses Hebrews’ apparently paradoxical, too infrequently noted use of “Son” to describe both who Jesus is and what he becomes. In an article that addresses the problem of Hebrews’ language of perfection, Silva writes,")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("The solution proposed in this article finds its theological basis in the statement at Hebrews 1:4, where we are told that God’s "), _c('i', [_vm._v("Son")]), _vm._v(" has inherited a name superior to that of the angels. But when we ask what is the name that this Son has inherited, the answer is, oddly enough, "), _c('i', [_vm._v("Son")]), _vm._v(" again (verses 5ff.). It is, I think, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "role": "doc-pagebreak",
      "title": "19"
    }
  }, [_vm._v("surprising that very little has been made in the past of the apparent fact that the author uses the word "), _c('i', [_vm._v("Son ")]), _vm._v("in two different senses in these verses. In verse 2 it indicates what Jesus is, and always has been, "), _c('i', [_vm._v("by divine nature")]), _vm._v("; in verses 4ff. it is the Messianic title He receives in connection with some type of change "), _c('i', [_vm._v("in his human nature")]), _vm._v(". Surely this temporal distinction—that "), _c('i', [_vm._v("after ")]), _vm._v("completing his work Jesus became something he was not before—accords naturally with the context: the participle γενόμενος (rather than ὤν) is used in verse 4 and the Father is quoted as addressing to Him the words, ‘"), _c('i', [_vm._v("Today")]), _vm._v(" I have begotten you’ (verse 5). Some commentators in the past have ignored the problem altogether; others have simply asserted that verse four does not affect the truth of Jesus’ eternal sonship, but they fail to explain adequately in what sense the name was inherited at the resurrection; still others have resorted to the questionable expedient that verse 4 refers merely to a divine "), _c('i', [_vm._v("declaration")]), _vm._v(" of what in fact has always been true."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-063",
      "id": "ap_ntb-063-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("I cite Silva at length because, first, he articulates precisely the solution to this puzzle that I will elaborate throughout the book. Second, it is noteworthy that incarnational concepts enable Silva to judge Hebrews’ twofold use of “Son” coherent. Silva can only make sense of Jesus both being Son and becoming Son by reading Hebrews as an incarnational narrative in which the divine Son lives a human life, achieves his people’s salvation, and as a consequence of all this becomes something he was not before. Many modern scholars balk at ascribing a divine nature to Jesus; many also balk at Hebrews’ apparently incoherent twofold use of “Son.” This is no coincidence. In order to read Hebrews’ narrative Christology coherently it is essential to recognize its fully incarnational logic. We can say coherently that the Son became Son only by saying that God became a man."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-064",
      "id": "ap_ntb-064-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "role": "doc-pagebreak",
      "title": "20"
    }
  }, [_vm._v("As far as I am aware, no modern author has offered a full-dress defense of the thesis that in Hebrews Jesus is the Son who became Son. Yet these three, and a few others like them, articulate in brief what I will develop at length."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#ntb-065",
      "id": "ap_ntb-065-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" They have perceived something essential to Hebrews’ entire argument, and that essential something merits patient attention.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REVIEW")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Our final preliminary to put in place is a preview of the book’s argument. In "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter one")]), _vm._v(" I will introduce six classical christological concepts and strategies of reading and predication that I will employ throughout the book. In the whole book I attempt to demonstrate that this classical christological toolkit enables us to read with the grain of Hebrews’ narrative Christology, to say about the Son all that Hebrews says about the Son and, ultimately, to perceive something of why Hebrews asserts that the Son became Son. In "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter two")]), _vm._v(" I will argue that Hebrews uses “Son” as a divine designation, more specifically, to designate Jesus’ distinct mode of divine existence. “Son” indicates that Jesus both is God and is distinct from the Father and, implicitly, the Spirit.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#chap-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter three")]), _vm._v(" I will narrate (most of) the Son’s incarnate mission according to Hebrews, from his entrance into human life to his death, resurrection, and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "role": "doc-pagebreak",
      "title": "21"
    }
  }, [_vm._v("entrance to heaven. I will argue that Hebrews not only characterizes Jesus as fully divine and fully human, but that it manifests a narrative incarnational logic, in two senses. First, "), _c('i', [_vm._v("incarnation")]), _vm._v(" names the Son’s "), _c('i', [_vm._v("entrance")]), _vm._v(" into human life. Second, what some scholars take to be fissures in Hebrews’ Christology are in fact deliberately plotted points of development, of tension and resolution. The Son not only had to become human, he had to be perfected through sufferings, pass through death into indestructible life, and thereby become his people’s source of salvation.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#chap-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter four")]), _vm._v(" I will argue that Jesus was appointed messianic Son at his enthronement in heaven. Hence my second thesis is this: “Son” designates the office of messianic rule to which Jesus is appointed at his exaltation. Hence also "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap4#chap-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter four")]), _vm._v(" follows "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#chap-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter three")]), _vm._v(" because Jesus can only be appointed Son once he has achieved his people’s salvation. Priestly sacrifice precedes kingly session; Jesus accomplishes salvation before he rests on the throne. It is not simply within his incarnate mission but at the telos of this mission that the Son became Son.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap5#chap-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter five")]), _vm._v(" I will argue the third thesis, that Jesus can only become the messianic Son because he is the divine Son incarnate. Jesus’ divinity is a necessary though not sufficient condition for his exercise of messianic rule. For Hebrews, “Messiah” is a theandric office; only the God-man can fill it. Finally, the conclusion will synthesize, extend, and apply the book’s findings. Specifically, I will briefly compare Hebrews’ Christology to that of Chalcedon, suggest that Acts 2:36 and Romans 1:3-4 also use one title in both a divine and a messianic sense, and reflect on the role of Christ’s person in Hebrews’ pastoral program.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-311759e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre7.vue
// module id = 78
// module chunks = 0